//@flow
import moment from 'moment'
import { combineReducers } from 'redux'
import {simpleReducer} from './../reducerHelpers';
import modals from './modals'

const hiddenPlatforms = (state = ['bitointalk'] , action) => {
  if(action.type === 'HIDE_PLATFORM') return [ ...state, action.payload ]
  if(action.type === 'SHOW_PLATFORM') return state.filter(p => p !== action.payload)
  if(action.type === 'SHOW_ALL_PLATFORMS') return []
  return state
}

export type Ui = {

}

export default combineReducers({
  test: (state = {}, action) => state,
  selectedCoin: simpleReducer({ 'SET_SELECTED_COIN': 'PAYLOAD', 'default': 'e557'}), // EOS is default...
  trackedDays: simpleReducer({ 'SET_TRACKED_DAYS': 'PAYLOAD', 'default': 7 }),
  untilDate: simpleReducer({ 'SET_UNTIL_DATE': 'PAYLOAD', 'default': moment().format('YYYYMMDD') }),
  highlightedPlatform: simpleReducer({ 'HIGHLIGHT_PLATFORM': 'PAYLOAD', 'default': 'reddit_a' }),
  hiddenPlatforms,
  modals,
})



// WEBPACK FOOTER //
// ./src/reducers/ui/index.js